export const setGlobalError = data => ({
  type: 'SET_GLOBAL_ERROR', payload: data,
})
